import { Box } from "@chakra-ui/react"
import SwitchButton from "@pathwright/ui/src/components/button/SwitchButton"
import { useScreensizeContext } from "@pathwright/ui/src/components/ui/Screensize"
import { useCohortSyncPlanContext } from "@pathwright/web/src/modules/path/sync/SyncPlanContext"
import { ConnectStores } from "lib/core/store"
import { PathContext } from "library/show/components/path/state/PathProvider"
import withAvailableModes from "library/show/components/path/withAvailableModes"
import { DESIGN, LEARN, TEACH } from "path/constants"
import { useContext } from "react"

const CONTROLS = [
  { icon: "edit", label: "Design", value: DESIGN },
  { icon: "group", label: "Teach", value: TEACH },
  { icon: "eye", label: "Learn", value: LEARN }
]

const PathModeControls = ({
  mode,
  availableModes,
  setMode,
  registration,
  offering
}) => {
  const screensize = useScreensizeContext()
  const iconMode = screensize === "sm" || screensize === "md"

  const { loading, cohortId, loadPath } = useContext(PathContext)

  const syncPlanContext = useCohortSyncPlanContext({
    cohortId
  })

  if (!mode || availableModes.length <= 1) return null

  const loadModePath = (mode) => {
    // effectively disables the SwitchButton while not changing its visual appearence
    if (loading) return

    let pathId = null
    // a designer with a registration will need to load their registration path to view their own path in LEARN mode
    if (mode === LEARN && availableModes.includes(DESIGN)) {
      pathId = registration ? registration.path : null
    }

    // load the path based on potentially changed path ID. This will only trigger a path load if the path ID has changed.
    loadPath({
      pathId,
      cohortId
    })

    setMode(mode)
  }

  const options = availableModes.map((mode) => {
    let option = CONTROLS.find((control) => control.value === mode)
    // hack ciry ahead. Change label to "Observe" for observer role
    if (option.value === LEARN && registration && registration.role === -1) {
      option.label = "Observe"
    }
    if (
      mode === DESIGN &&
      !offering?.is_curriculum &&
      syncPlanContext.forward?.groupedChanges?.syncable?.length
    ) {
      option.indicator = true
    } else {
      option.indicator = false
    }
    return option
  })

  let activeIndex = options.findIndex((option) => option.value === mode)
  if (activeIndex === -1) activeIndex = 0

  return (
    <Box
      className="PathModeControls"
      sx={{
        ".CountIndicator.CountIndicator--empty": {
          fontSize: "1em",
          bgColor: "rgba(255,255,255,0.9) !important",
          right: "0.6em",
          opacity: mode === TEACH ? 1 : 0
        }
      }}
    >
      <SwitchButton
        inverted
        iconMode={iconMode}
        options={options}
        onChange={(index) => {
          const mode = options[index].value
          loadModePath(mode)
        }}
        activeIndex={activeIndex}
      />
    </Box>
  )
}

PathModeControls.displayName = "PathModeControls"

const stores = [
  {
    store: "path",
    watch: ["mode"]
  },
  {
    store: "resource",
    watch: ["registration", "offering"]
  }
]

export default withAvailableModes(
  ConnectStores(PathModeControls, stores, {}, (state, ownProps) => {
    const { registration, offering } = state.resourceStore.state
    const { mode } = state.pathStore.state
    const { setMode } = state.pathStore.action

    return {
      mode,
      setMode,
      registration,
      offering,
      ...ownProps
    }
  })
)
